import { c as _c } from "react/compiler-runtime";
import { useSyncFilterFE } from '@netpurpose/core';
import { NOT_FOUND } from '@netpurpose/types';
import { type Dispatch, type SetStateAction, useState } from 'react';
export const useNdNaFilters = data => {
  const $ = _c(18);
  const [showNotDisclosed, setShowNotDisclosed] = useState(false);
  const [showNotApplicable, setShowNotApplicable] = useState(false);
  let t0;
  if ($[0] !== data || $[1] !== showNotApplicable || $[2] !== showNotDisclosed) {
    t0 = data?.filter(datum => {
      if (datum.absolute && datum.absolute.unit !== NOT_FOUND || datum.unweightedPortfolioImpact && datum.unweightedPortfolioImpact.unit !== NOT_FOUND) {
        return true;
      }
      if (!datum.isNd && showNotApplicable) {
        return true;
      }
      if (datum.isNd && showNotDisclosed) {
        return true;
      }
      return false;
    });
    $[0] = data;
    $[1] = showNotApplicable;
    $[2] = showNotDisclosed;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const dataWithNdNaFilters = t0 as Data | undefined;
  let t1;
  if ($[4] !== showNotDisclosed) {
    t1 = [showNotDisclosed];
    $[4] = showNotDisclosed;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = options => setShowNotDisclosed(options[0] as boolean);
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1) {
    t3 = {
      name: "show-not-disclosed",
      selectedOptions: t1,
      setSelectedOptions: t2
    };
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useSyncFilterFE(t3);
  let t4;
  if ($[9] !== showNotApplicable) {
    t4 = [showNotApplicable];
    $[9] = showNotApplicable;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = options_0 => setShowNotApplicable(options_0[0] as boolean);
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4) {
    t6 = {
      name: "show-not-applicable",
      selectedOptions: t4,
      setSelectedOptions: t5
    };
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useSyncFilterFE(t6);
  let t7;
  if ($[14] !== dataWithNdNaFilters || $[15] !== showNotApplicable || $[16] !== showNotDisclosed) {
    t7 = {
      dataWithNdNaFilters,
      showNotDisclosed,
      setShowNotDisclosed,
      showNotApplicable,
      setShowNotApplicable
    };
    $[14] = dataWithNdNaFilters;
    $[15] = showNotApplicable;
    $[16] = showNotDisclosed;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};